// Panda Paradise — locked audio map (03_AUDIO/AUDIO_MAP_LOCKED.txt).
const BASE = "/games/panda-paradise/audio";
const SRC = {
  trigger: `${BASE}/PP-A01_FreePlay_Trigger_Transition.wav`,
  freeStart: `${BASE}/PP-A06_FreeSpins_Start_Voice.wav`,
  music: `${BASE}/PP-A02_Base_Game_Background_Music.wav`,
  bigwin: `${BASE}/PP-A03_Feature_Result_Large_Win_Reveal.wav`,
  anticip: `${BASE}/PP-A04_FreePlay_Anticipation_Almost_Win.wav`,
  coin: `${BASE}/PP-A05_Gold_Coin_Landing.wav`,
};

class PandaAudio {
  constructor() {
    this.enabled = true;
    this.unlocked = false;
    this.music = null;
    this._buffers = {};
    this._ctx = null;
  }
  unlock() {
    if (this.unlocked) return;
    this.unlocked = true;
    // Preload sfx elements.
    ["trigger", "bigwin", "anticip", "coin"].forEach((k) => {
      const a = new Audio(SRC[k]);
      a.preload = "auto";
      this._buffers[k] = a;
    });
  }
  startMusic(vol = 0.5) {
    if (!this.enabled) return;
    if (!this.music) {
      this.music = new Audio(SRC.music);
      this.music.loop = true;
      this.music.volume = vol;
    }
    this.music.volume = vol;
    this.music.play().catch(() => {});
  }
  setMusicVolume(v) { if (this.music) this.music.volume = Math.max(0, Math.min(1, v)); }
  stopMusic() { if (this.music) { try { this.music.pause(); } catch (_e) {} } }
  _play(key, vol = 0.8) {
    if (!this.enabled || !this.unlocked) return;
    try {
      const a = new Audio(SRC[key]);
      a.volume = vol;
      a.play().catch(() => {});
    } catch (_e) { /* noop */ }
  }
  // Play a clip but cut it off at a fraction of its length (keeps long stingers short).
  _playClipped(key, vol = 0.8, fraction = 0.5, maxMs = 1600) {
    if (!this.enabled || !this.unlocked) return;
    try {
      const a = new Audio(SRC[key]);
      a.volume = vol;
      const stop = (ms) => setTimeout(() => {
        const step = a.volume / 5;
        const fade = setInterval(() => {
          a.volume = Math.max(0, a.volume - step);
          if (a.volume <= 0.01) { clearInterval(fade); try { a.pause(); } catch (_e) {} }
        }, 40);
      }, ms);
      a.addEventListener("loadedmetadata", () => {
        const ms = Math.min(maxMs, (a.duration || 2) * 1000 * fraction);
        stop(ms);
      });
      stop(maxMs); // fallback if metadata never fires
      a.play().catch(() => {});
    } catch (_e) { /* noop */ }
  }
  coin(vol = 0.7) { this._play("coin", vol); }
  trigger() { this._playClipped("trigger", 0.9, 1.0, 4000); }  // free-play sting, full length
  freeStart() { this._play("freeStart", 1.0); }  // high-pitched voice → Free Spins start
  bigwin() { this._play("bigwin", 0.9); }
  // Short, snappy line-win chime (Web Audio, ~380ms) so base wins don't drag.
  win() {
    if (!this.enabled || !this.unlocked) return;
    try {
      if (!this._ctx) this._ctx = new (window.AudioContext || window.webkitAudioContext)();
      const ctx = this._ctx;
      if (ctx.state === "suspended") ctx.resume().catch(() => {});
      const now = ctx.currentTime;
      const notes = [784, 988, 1319]; // G5 B5 E6
      notes.forEach((f, i) => {
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = "triangle";
        o.frequency.value = f;
        const t = now + i * 0.075;
        g.gain.setValueAtTime(0, t);
        g.gain.linearRampToValueAtTime(0.22, t + 0.015);
        g.gain.exponentialRampToValueAtTime(0.001, t + 0.22);
        o.connect(g); g.connect(ctx.destination);
        o.start(t); o.stop(t + 0.24);
        o.onended = () => { try { o.disconnect(); g.disconnect(); } catch (_e) {} };
      });
    } catch (_e) { /* noop */ }
  }
  anticipation() { this._play("anticip", 0.7); }
  setEnabled(on) {
    this.enabled = on;
    if (!on) this.stopMusic();
    else this.startMusic();
  }
}

export const pandaAudio = new PandaAudio();
